import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';

const RadioWidget = (opts: WidgetProps) => {
  const orientation = opts.schema.orientation;
  const label = opts.label;
  const name = opts.name;
  const options = opts.options.enumOptions ?? [];

  return (
    <FormControl required={opts.required}>
      <FormLabel id={`${name}-label`}>{label}</FormLabel>
      <RadioGroup
        aria-labelledby={`${name}-label`}
        name={name}
        row={orientation === 'horizontal'}
        onChange={(e) => opts.onChange(e.target.value)}
      >
        {options.map((option) => (
          <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioWidget;